import { useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { Navigate, useNavigate, Link } from "react-router-dom";
import { ArrowLeft, LogIn } from "lucide-react";

export default function AdminLogin() {
    const { user, login } = useAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    if (user && user.role === "admin") {
        return <Navigate to="/admin/dashboard" replace />;
    }

    const onSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);
        const result = await login(email, password);
        setLoading(false);
        if (result.ok) {
            navigate("/admin/dashboard", { replace: true });
        } else {
            setError(result.error || "Login failed");
        }
    };

    return (
        <div data-testid="admin-login-page" className="min-h-screen bg-[#F9F8F6] flex items-center justify-center px-6 py-16">
            <div className="w-full max-w-md">
                <Link to="/" data-testid="admin-login-back" className="inline-flex items-center gap-2 text-sm text-[#5C5853] hover:text-[#1A1817] mb-10">
                    <ArrowLeft className="w-4 h-4" /> Back to site
                </Link>

                <p className="overline">Restricted Area</p>
                <h1 className="font-serif text-5xl tracking-tight mt-3">Admin sign in.</h1>
                <p className="text-sm text-[#5C5853] mt-4 max-w-sm">
                    For Will Maxwell only. Sign in to upload, edit, and manage portfolio frames.
                </p>

                <form onSubmit={onSubmit} className="mt-10 space-y-7" data-testid="admin-login-form">
                    <div>
                        <label className="overline">Email</label>
                        <input
                            data-testid="admin-login-email"
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="input-underline"
                            placeholder="admin@willmaxwellphoto.com"
                            required
                            autoFocus
                        />
                    </div>
                    <div>
                        <label className="overline">Password</label>
                        <input
                            data-testid="admin-login-password"
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="input-underline"
                            placeholder="••••••••"
                            required
                        />
                    </div>
                    {error && (
                        <p data-testid="admin-login-error" className="text-sm text-[#7A2E2E]">{error}</p>
                    )}
                    <button
                        type="submit"
                        disabled={loading}
                        data-testid="admin-login-submit"
                        className="btn-editorial primary w-full justify-center disabled:opacity-60"
                    >
                        {loading ? "Signing in…" : (<>Sign in <LogIn className="w-4 h-4" /></>)}
                    </button>
                </form>
            </div>
        </div>
    );
}
